import { render, staticRenderFns } from "./shiyanshiDetail.vue?vue&type=template&id=741278ea&scoped=true"
import script from "./shiyanshiDetail.vue?vue&type=script&lang=js"
export * from "./shiyanshiDetail.vue?vue&type=script&lang=js"
import style0 from "./shiyanshiDetail.vue?vue&type=style&index=0&id=741278ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741278ea",
  null
  
)

export default component.exports